<template>
  <grid-loader :loading="isLoading" :color="spinnerColor" class="middle_abs"></grid-loader>
  <button class="returnBtn" @click="back">返回</button>
  <div class="mt-1 container">
    <div v-if="account!=undefined && account.user_info !=undefined" class="d-flex justify-content">
              <div v-if="account.user_info.avatar!=undefined">
                <img :src="account.user_info.avatar" style="width:125rem;height:1.25rem">
              </div>
              <div class="d-flex flex-row align-items-center">
                  <div>{{account.user_info.nickName}}</div>
              </div>
      </div>

      <div>
        <div class="d-flex justify-content-between align-items-center">
          <div class="d-flex justify-content align-items-center">
          
            <div class="topTitle">账号管理</div>
         
        </div>
       
        <div class="btnAdd" @click="updateTitle"><img src="../assets/icon-edit.png">修改</div>
      </div>
        <table class="mt-1 table_title">
          <tr>
            <th>选题</th>
          
            <th>天数</th>
            <th>发布数</th>
            <th>有效</th>
            <th>添加日期</th>
          </tr>
          <tr v-for="(title, index) in titles" :key="index">
            <td>{{ title.user_input}}</td>
          
            <td>{{ title.day}}</td>
            <td>{{ title.day_count}}</td>
            <td>
              <span v-if="title.valid==false" class="invalidText">失效</span>
              <span v-else class="validText">有效</span>
              </td>

             
            <td>{{ localDatetime(title.createdDate) }}</td>
          </tr>
        </table>
      </div>

      <div class="mt-1">
          <!-- <PopupWindow v-model:isShow="ifAdd">
            
                
            <AddAccount @add_account_suc="updateAccounts" :isUpdate="true" :accountId="accountId"></AddAccount>
      </PopupWindow> -->
         
      </div>
     
  </div>
</template>

<script>

import GridLoader from 'vue-spinner/src/GridLoader.vue'
import axios from 'axios';
import moment from 'moment'
// import PopupWindow from '@/components/PopupWindow.vue';
// import AddAccount from '@/components/AddAccount.vue';



export default {
  data(){

    return {
      isLoading:false,
      spinnerColor:"#262626",
    
      errors:'',
      accountId:'',
      account:null,
      titles:[],
    
      ifAdd:false
    }
    
  },
  computed: {
  localDatetime() {
    return (datetimeString) => {
      let beijingTime = moment(datetimeString).utcOffset('+08:00').format('YYYY-MM-DD HH:mm:ss');
      return beijingTime
      
    }
  }
},

  components: {
    GridLoader,
    // PopupWindow,
    // AddAccount
  },
   setup(){
     var token=localStorage.getItem('sessionToken')
       
          if(token==undefined || token==null ||token=='')
        {
          this.$router.push('index')
          return
        }
     axios.defaults.headers.common['X-Parse-Session-Token'] = token
  },


  mounted(){
    var token=localStorage.getItem('sessionToken');

     if(token==undefined && token!=null &&token!='')
     {

      this.$router.push('index')
      return
     }
     this.accountId = this.$route.params.id;

    this.getAccounts()
  },
  methods:{
    back(){
      this.$router.go(-1)
    },
    updateTitle(){
      this.$router.push('/index/user/newAccount/'+this.accountId)
    }, 
    async getAccounts(){
      try{
          this.isLoading=true
          const response = await axios.get(this.domain+'xhs/get_account_by_id?account_id='+this.accountId);

          var data=response.data
          if(data.status=='Suc')
          {

              this.account=data['account']
              this.titles=data['titles']
            
          }
          else
          {
              console.error(data)
              
          }
      }
      catch(error)
      {
          console.error(data)
      }
      finally{
        this.isLoading=false
      }
    },

    updateAccounts(title){
      this.titles[0]['valid']=false
      this.titles.unshift(title)
      this.ifAdd=false
    },


   
  }
   
  
};
</script>
